<script>
import { formatDatePretty, humanReadableHours } from '@/utils';
import { diffKinds as kinds, entityTypes } from '../constants';
import DiffAdmin from './DiffAdmin';
import DiffSettings from './DiffSettings';
import DiffWeekends from './DiffWeekends';

export default {
  props: {
    entityId: {
      type: String,
      default: '',
    },
    entityType: {
      type: String,
      required: true,
    },
    changes: {
      type: Array,
      required: true,
    },
  },
  computed: {
    mapDepartments () {
      return this.$store.state.dict.departments;
    },
    mapProjects () {
      return this.$store.state.dict.projects;
    },
    mapWorkers () {
      return this.$store.state.dict.workers;
    },
  },
  methods: {
    formatField (field) {
      const { entityType } = this;

      if (entityType === entityTypes.department) {
        if (field === 'name') {
          return 'Название';
        }
        if (field === 'color') {
          return 'Цвет';
        }
      }

      if (entityType === entityTypes.log) {
        if (field === 'date') {
          return 'Дата';
        }
        if (field === 'hours') {
          return 'Трудозатраты';
        }
        if (field === 'task') {
          return 'Задача';
        }
        if (field === 'project') {
          return 'Проект';
        }
        if (field === 'worker') {
          return 'Сотрудник';
        }
      }

      if (entityType === entityTypes.project) {
        if (field === 'name') {
          return 'Название';
        }
        if (field === 'search') {
          return 'Синонимы';
        }
      }

      if (entityType === entityTypes.worker) {
        if (field === 'department') {
          return 'Департамент';
        }
        if (field === 'name') {
          return 'Настоящее имя';
        }
        if (field === 'sex') {
          return 'Пол';
        }
        if (field === 'track') {
          return 'Отслеживать';
        }
      }

      return field;
    },
    formatValue (field, value) {
      const { entityType } = this;

      if (entityType === entityTypes.department) {
        if (field === 'color') {
          return (
            <span>
              {value}
              <span
                class="journal-diff__color-badge"
                style={{ color: value }}
              />
            </span>
          );
        }
      }

      if (entityType === entityTypes.log) {
        if (field === 'date') {
          return formatDatePretty(value);
        }
        if (field === 'hours') {
          return humanReadableHours(Number.parseFloat(value));
        }
        if (field === 'project') {
          return (this.mapProjects[value] || {}).name || value;
        }
        if (field === 'worker') {
          const worker = this.mapWorkers[value];
          return worker ? worker.name : value;
        }
      }


      if (entityType === entityTypes.worker) {
        if (field === 'department') {
          return (this.mapDepartments[value] || {}).name || value;
        }
        if (field === 'sex') {
          if (value === 'm') {
            return 'мужской';
          }
          if (value === 'f') {
            return 'женский';
          }
        }
        if (field === 'track') {
          if (String(value) === 'true') {
            return 'да';
          }
          if (String(value) === 'false') {
            return 'нет';
          }
        }
      }

      return value;
    },
  },
  render () {
    if (this.entityType === entityTypes.admin) {
      return <DiffAdmin changes={this.changes} />;
    }

    if (this.entityType === entityTypes.settings) {
      return (
        <DiffSettings
          entityId={this.entityId}
          changes={this.changes}
        />
      );
    }

    if (this.entityType === entityTypes.weekends) {
      return <DiffWeekends changes={this.changes} />;
    }

    const { formatField, formatValue } = this;

    return (
      <div>
        {this.changes.map((change, i) => {
          const [field] = change.path;
          const lhs = change.kind !== kinds.add ? String(change.lhs) : null;
          const rhs = change.kind !== kinds.remove ? String(change.rhs) : null;

          if (!lhs && !rhs) {
            return null;
          }

          return (
            <div
              key={i}
              class="journal-diff"
            >
              <div class="journal-diff__field">
                {formatField(field)}
              </div>
              {lhs && (
                <span class="journal-diff__del">
                  {formatValue(field, lhs)}
                </span>
              )}
              {rhs && (
                <span class="journal-diff__ins">
                  {formatValue(field, rhs)}
                </span>
              )}
            </div>
          );
        })}
      </div>
    );
  },
};
</script>

<style lang="scss">
@import '@/theme/include.scss';

.journal-diff {
  & + & {
    margin-top: 1em;
  }

  &__del,
  &__ins {
    display: inline-block;
    padding: .125em .5em 0;
  }

  &__del {
    background-color: rgba($color-red-lightest, .5);
    color: $color-red-darkest;
    text-decoration: line-through;
  }

  &__ins {
    background-color: rgba($color-green-lightest, .5);
    color: $color-green-darkest;
  }

  &__color-badge {
    background-color: currentColor;
    border: thin solid $color-white;
    border-radius: 50%;
    display: inline-block;
    height: 1em;
    margin-left: .25em;
    margin-top: -.25em;
    vertical-align: middle;
    width: 1em;
  }
}
</style>
